import React from 'react';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

type Props = {
  label: string;
  options: string[];
  required?: boolean;
  value?: string;
};

/**
 * ガイド画面で表示用のモックラジオグループ（操作不能）
 */
const GuideMockRadioGroup: React.FC<Props> = ({ label, options, required = false, value }) => {
  return (
    <FormControl required={required} sx={{ pointerEvents: 'none' }}>
      <FormLabel sx={{ fontSize: '0.875rem', mb: 0.5 }}>{label}</FormLabel>
      <RadioGroup row value={value || ''}>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={<Radio size="small" />}
            label={option}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default GuideMockRadioGroup;
